import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import SectionDivider from "@/components/base/SectionDivider";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Faq() {
  useDocumentMeta({
    title: "SSS | d.mar Dental Görüntüleme Merkezi",
    description:
      "Randevu, çekim süresi, rapor teslimi ve radyasyon dozu hakkında en çok sorulan sorular ve net yanıtları: d.mar Dental Görüntüleme Merkezi.",
    path: "/sss",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="SSS"
        eyebrow="Sıkça sorulan sorular"
        title="Merak ettikleriniz, açıkça yanıtlandı"
        description="Randevu, çekim süresi, rapor teslimi ve doz güvenliğiyle ilgili en çok sorulan soruların yanıtları burada."
      />
      <FaqSection />
      <SectionDivider />
      <CtaSection />
    </SiteLayout>
  );
}